module.exports = __webpack_public_path__ + "img/18.53bbe7f1.png";